import ApiResourceManager from '../ApiResourceManager';

/**
 * The licence paywall, partner side. No on-behalf header: partner admins are
 * pinned to their own provider by the backend middleware, and the company
 * scope is re-asserted there too.
 */
export default class PartnerLicensesManager extends ApiResourceManager {
  /** What this restaurant may buy, and what it already holds. */
  entitlements = (companyId) =>
    this.request({
      method: 'GET',
      url: `/partner-licenses/companies/${companyId}`,
    });

  /**
   * Subscribe. Answers with the same payload as `entitlements`, so the success
   * state needs no second call. `gate` names the paywall the purchase came from
   * (live_orders, reservations, …), for the backend's subscription_changed.
   */
  activate = (companyId, productKey, { gate = null } = {}) =>
    this.request({
      method: 'POST',
      url: `/partner-licenses/companies/${companyId}/activate`,
      data: { product_key: productKey, terms_accepted: true, ...(gate ? { gate } : {}) },
    });
}
